import { Box, Button, customStyled, variant } from '@mafc/trolly';
import { ENotificationVariant, TNotificationVariant } from '../types';
import COLORS from 'theme/colors';
import SPACINGS from 'theme/spacings';

export const InlineNotificationContainer = customStyled.div<{
  variant: TNotificationVariant;
  showBorder?: boolean;
}>`
    padding: ${SPACINGS[14]} ${SPACINGS[16]};
    border-radius: ${SPACINGS[4]};
    display: flex;
    align-items: center;
    line-height: ${SPACINGS[20]};
    margin-bottom: ${SPACINGS[16]};
    ${props =>
      variant({
        variants: {
          [ENotificationVariant.WARNING]: {
            backgroundColor: COLORS.GOLDEN_BELL_25,
            color: COLORS.GOLDEN_BELL_600,
            ...(props.showBorder && {
              border: `1px solid ${COLORS.GOLDEN_BELL_50}`,
            }),
          },
          [ENotificationVariant.INFO]: {
            backgroundColor: COLORS.INFO_25,
            color: COLORS.INFO_600,
          },
          [ENotificationVariant.SUCCESS]: {
            backgroundColor: COLORS.SUCCESS_25,
            color: COLORS.SUCCESS_600,
          },
          [ENotificationVariant.ERROR]: {
            backgroundColor: COLORS.ERROR_RED_25,
            color: COLORS.ERROR_RED_500,
          },
        },
      })}
`;

export const ButtonWrapper = customStyled(Button)`
    color: inherit;
    height: auto;
    font-weight: ${({ theme }) => theme.fontWeights[7]};
    margin-left: ${({ theme }) => theme.space[3]}px;
`;

export const IconBox = customStyled(Box)(({ theme }) => ({
  minWidth: theme.space[4],
  width: theme.space[4],
  height: theme.space[4],
  paddingRight: theme.space[1],
}));

export const Icon = customStyled(Box)(() => ({
  flex: '0 0 24px',
  height: '24px',
}));
